module.exports = __webpack_public_path__ + "static/media/stepThree.478fb6dc.png";